<template>
  <div id="campaign-ongoing">
    <section class="content">
      <div class="box">
        <div class="box-header">
          <button type="button" class="btn btn-primary btn-sm" @click="paginate(1)">
            <i class="fa fa-repeat"></i>
          </button>
        </div>
        <div class="box-body">
          <b-table striped hover :items="campaigns" :fields="fields">
            <template v-slot:cell(actions)="row">
              <div class="btn-group" role="group" aria-label="Basic example">
                <!-- view -->
                <button type="button" data-toggle="modal" data-target="#view_pairing_brief_detailed_modal" class="btn btn-primary" @click="getCampaignDataToView(row.item.id); getRateCardDataToView(row.item.id,influencerID);">
                  <i class="fa fa-eye"></i>
                </button>

                <!-- Pairing Influencer "Accept" button -->
                <button type="button" class="btn btn-success" v-if="buttonShowPairing(row.item.pairingStatus)" @click="acceptInvite(row.item.pairingID)">
                  <i class="fa fa-check"></i>
                </button>

                <!-- clientReject -->
                <button type="button" class="btn btn-danger" v-if="buttonShowPairing(row.item.pairingStatus)" @click="rejectCampaign(row.item.id)">
                  <i class="fa fa-times"></i>
                </button>

                <!-- Post "view" button -->
                <button type="button" class="btn btn-primary" v-if="!buttonShowPairing(row.item.pairingStatus)" data-toggle="modal" data-target="#view_post_modal" @click="getPostDataToView(row.item)">
                  <i class="fa fa-file"></i>
                </button>
              </div>
            </template>
          </b-table>
        </div>
        <div class="box-footer">
          <b-pagination :total-rows="totalRows" :per-page="perPage" v-model="currentPage" size="md" />
        </div>
      </div>
    </section>
    <view-pairing-brief-detailed-modal :modalId="'view_pairing_brief_detailed_modal'" :campaignData="viewCampaignData" :rateCardData="viewRateCardData"/>
    <view-post-modal :modalId="'view_post_modal'" :campaignData="viewPostCampaignData" />
  </div>
</template>

<script>
import moment from 'moment'
import config from '@/config'
import campaignAPIs from './campaignAPIs'
import campaignConfig from './config'
import ViewPairingBriefDetailedModal from './ViewPairingBriefDetailedModal'
import ViewPostModal from './ViewPostModal'

export default {
  name: 'campaign-ongoing',
  components: {
    ViewPairingBriefDetailedModal,
    ViewPostModal
  },
  data() {
    return {
      campaignStatus: this.$route.meta.campaignStatus,
      currentPage: 1,
      perPage: 15,
      totalRows: 0,
      campaigns: [],
      viewRateCardData: 0,
      influencerID: '',
      keyword: '',
      fields: [
        {
          key: 'pairingStatusDisplay',
          label: 'Status'
        },
        {
          key: 'name'
        },
        {
          key: 'updatedAt'
        },
        {
          key: 'actions'
        }
      ],
      viewCampaignData: null,
      viewPostCampaignData: null
    }
  },
  created() {
    this.paginate(1)
    this.userID = this.$store.state.user.id
    this.influencerID = this.getInfluencerID(this.userID)
  },
  watch: {
    currentPage() {
      this.paginate(this.currentPage)
    }
  },
  methods: {
    paginate(page = 1) {
      this.currentPage = page
      campaignAPIs
        .paginate({
          page: page,
          per_page: this.perPage,
          status: `${config.campaignStatus.PAIRING_INFLUENCER},${config.campaignStatus.ONGOING}`,
          pairingStatus: campaignConfig.pairingStatus.INTERESTED,
          keyword: this.keyword,
          sort: 'updatedAt DESC',
          hasInstagramURL: false
        })
        .then(response => {
          let campaigns = response.campaigns

          campaigns = campaigns.map(item => {
            item.pairingStatusDisplay = campaignConfig.pairingStatusDisplay[item.status]
            item.updatedAt = this.formatTime(item.updatedAt)
            return item
          })

          this.campaigns = campaigns
          this.totalRows = response.totalCampaigns
        })
        .catch(error => {
          console.log('error', error)
        })
    },

    getInfluencerID(userID) {
      campaignAPIs
        .getInfluencerID(userID)
        .then(response => {
          this.influencerID = response
        })
        .catch(error => {
          // Request failed.
          console.log('error', error)
        })
    },

    getRateCardDataToView(campaignID, influencerID) {
      campaignAPIs
        .getRateCard(campaignID, influencerID)
        .then(response => {
          if (response === []) {
            this.viewRateCardData = 0
          } else {
            this.viewRateCardData = response[0].approvedRateCard
          }
        })
        .catch(error => {
          // Request failed.
          console.log('error', error)
        })
    },

    getCampaignDataToView(campaignID) {
      campaignAPIs
        .getCampaign(campaignID)
        .then(response => {
          this.viewCampaignData = response
        })
        .catch(error => {
          // Request failed.
          console.log('error', error)
        })
    },

    approveCampaign(campaignID) {
      // Get campaign confirmation configuration
      var campaignConfirmation = campaignConfig.campaignConfirmation.approval[this.campaignStatus]

      // Display confirmation box
      this.$swal({
        title: campaignConfirmation['confirmation']['title'],
        text: campaignConfirmation['confirmation']['text'],
        type: campaignConfirmation['confirmation']['type'],
        showCancelButton: true,
        confirmButtonText: campaignConfirmation['confirmation']['confirmText'],
        cancelButtonText: campaignConfirmation['confirmation']['cancelText'],
        showCloseButton: true,
        showLoaderOnConfirm: true,
        preConfirm: login => {
          return campaignAPIs
            .approveCampaign(campaignID, this.campaignStatus)
            .then(response => {
              return response
            })
            .catch(error => {
              // Request failed.
              console.log('error', error)

              // Show error message
              this.$swal.showValidationError('Something went wrong! Please try again or contact our admin')
            })
        },
        allowOutsideClick: () => !this.$swal.isLoading()
      }).then(result => {
        if (result.value) {
          // Refresh campaign list
          this.paginate(1)

          // Delete local data for the new status list to force refresh
          this.$store.commit('SET_CAMPAIGNS', {
            campaignStatus: campaignConfig.campaignStatusFlow['approve'][this.campaignStatus],
            data: null
          })

          // Show success message
          this.$swal({
            title: campaignConfirmation['confirm']['title'],
            text: campaignConfirmation['confirm']['text'],
            type: 'success'
          })
        } else {
          // Do nothing for now
        }
      })
    },
    buttonShowPairing(pairingStatus) {
      return pairingStatus === campaignConfig.pairingStatus.INVITED
    },
    rejectCampaign(campaignID) {
      // Get campaign confirmation configuration
      var campaignConfirmation = campaignConfig.campaignConfirmation.reject[this.campaignStatus]

      // Display confirmation box
      this.$swal({
        title: campaignConfirmation['confirmation']['title'],
        text: campaignConfirmation['confirmation']['text'],
        type: campaignConfirmation['confirmation']['type'],
        showCancelButton: true,
        confirmButtonText: campaignConfirmation['confirmation']['confirmText'],
        cancelButtonText: campaignConfirmation['confirmation']['cancelText'],
        showCloseButton: true,
        showLoaderOnConfirm: true,
        preConfirm: login => {
          return campaignAPIs
            .rejectCampaign(campaignID, this.campaignStatus)
            .then(response => {
              return response
            })
            .catch(error => {
              // Request failed.
              console.log('error', error)

              // Show error message
              this.$swal.showValidationError('Something went wrong! Please try again or contact our admin')
            })
        },
        allowOutsideClick: () => !this.$swal.isLoading()
      }).then(result => {
        if (result.value) {
          // Refresh campaign list
          this.paginate(true)

          // Delete local data for the new status list to force refresh
          this.$store.commit('SET_CAMPAIGNS', {
            campaignStatus: campaignConfig.campaignStatusFlow['reject'][this.campaignStatus],
            data: null
          })

          // Show success message
          this.$swal({
            title: campaignConfirmation['confirm']['title'],
            text: campaignConfirmation['confirm']['text'],
            type: 'success'
          })
        } else {
          // Do nothing for now
        }
      })
    },
    formatTime(value) {
      return moment(value).format('YYYY-MM-DD hh:mm:ss')
    },
    acceptInvite(pairingID) {
      campaignAPIs
        .acceptInvite(pairingID)
        .then(response => {
          // Refresh campaign list
          this.paginate(1)

          // Delete local data for the new status list to force refresh
          this.$store.commit('SET_CAMPAIGNS', {
            campaignStatus: campaignConfig.campaignStatusFlow['approve'][this.campaignStatus],
            data: null
          })
        })
        .catch(error => {
          // Request failed.
          console.log('error', error)
        })
    },
    getPostDataToView(campaignData) {
      this.viewPostCampaignData = campaignData
    }
  }
}
</script>




// WEBPACK FOOTER //
// CampaignOngoing.vue?9efdc8ea